import React from 'react';


export default function useMobileHandler() {
    const [isMobile, setIsMobile] = React.useState();

    React.useEffect(() => {
        const handleResize = () => {
              setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {isMobile};
}